var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresenceMeeting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.31,18H10.63V16.31H21.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.62,10a1.92,1.92,0,0,1,1.84-2h.17a2,2,0,0,1,2,1.9h0v.07a2,2,0,0,1-2,2h0a2,2,0,0,1-2-1.92h0Z",
    style: {
      fill: "#9767b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.22,19V14.33A1.36,1.36,0,0,1,24.15,13a1,1,0,0,1,.76,1v6.46a1.18,1.18,0,0,1-1.15,1.22H20.48c-.17.77-.33,1.58-.5,2.37-.06.33-.12.65-.2,1a1.09,1.09,0,0,1-1.22,1h-.2a1.09,1.09,0,0,1-.92-1.24h0v-.07c.3-1.53.61-3.07.94-4.6A1.24,1.24,0,0,1,19.72,19Z",
    style: {
      fill: "#9767b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66,18.93h2.5A1.22,1.22,0,0,1,13.5,20v.07c.28,1.43.56,2.87.83,4.31a1.16,1.16,0,0,1-.72,1.47h0a.85.85,0,0,1-.31.06c-.62.11-1.12-.33-1.27-1.09-.19-.95-.4-1.89-.57-2.85A.38.38,0,0,0,11,21.6H8.09a1.2,1.2,0,0,1-1.17-1.22h0V14a1,1,0,0,1,1-1,4.82,4.82,0,0,1,.76,0,.91.91,0,0,1,.89.76,2.5,2.5,0,0,1,.09.77v4.46Z",
    style: {
      fill: "#9767b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.67,15.73V11.61a1.21,1.21,0,0,1,1.27-1.13h0a1.18,1.18,0,0,1,.63.23,2.55,2.55,0,0,0,2.78,0,1.24,1.24,0,0,1,1.71.37,1.16,1.16,0,0,1,.19.44,5.61,5.61,0,0,1,0,.58v3.64Z",
    style: {
      fill: "#9767b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,6a2,2,0,0,1,2,1.91h0V8a2,2,0,1,1-4,.34V8A1.93,1.93,0,0,1,15.9,6H16Z",
    style: {
      fill: "#9767b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.38,9.89a2,2,0,0,1-1.88,2H8.42a2,2,0,0,1-2-1.86V9.86a2,2,0,0,1,2-2,2,2,0,0,1,2,1.94Z",
    style: {
      fill: "#9767b8"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceMeeting);
export default __webpack_public_path__ + "static/media/presence-meeting.dd865b6d.svg";
export { ForwardRef as ReactComponent };